export default "__VITE_ASSET__B3K7dZPO__"